import React from 'react';

const SvgClock = props => (
  <svg width="20" viewBox="0 0 20 20" {...props}>
    <path
      d="M16 10.99a1 1 0 0 1-1 1h-4a1.991 1.991 0 0 1-1.99-2v-5a1 1 0 1 1 1.99 0v4a1 1 0 0 0 1 1h3a1 1 0 0 1 1 1zm4-1a10 10 0 1 1-9.99-10 10 10 0 0 1 9.99 10zm-2 0a8 8 0 1 0-7.99 8 8.009 8.009 0 0 0 7.99-8z"
      fill={props.color}
      fillRule="evenodd"
    />
  </svg>
);

export default SvgClock;
